import { UserType } from '../../entities';
import { AppSecurityRight, ClaimSecurityModule, ConfigurationSecurityRight, CrmSecurityModule, CrmSecurityRight, DashboardSecurityRight, FinanceSecurityModule, FinanceSecurityRight, JobSecurityModule, JobSecurityRight, TimesheetSecurityModule, VariationSecurityModule } from '../modules';
import { SecurityRole, SecurityRoleType } from '../security.role';


export class EmployeeFinance implements SecurityRole {

    _id = '0673fa47-c26a-4dc5-a989-847e3e331920';
    system = true;
    hidden = false;
    name = SecurityRoleType.EmployeeFinance;
    type = UserType.Employee;
    description = 'Can manage customers, manage jobs, manage quotes and generate invoices';
    rights = [
        AppSecurityRight.LoginWeb,

        ConfigurationSecurityRight.AccessMetadata,
        ConfigurationSecurityRight.AccessPricing,
        ConfigurationSecurityRight.AccessTenancy,

        ConfigurationSecurityRight.ManageMetadata,
        ConfigurationSecurityRight.ManagePricing,
        ConfigurationSecurityRight.ManageTenancy,

        ConfigurationSecurityRight.AccessTemplates,
        ConfigurationSecurityRight.AccessDocumentThemes,
        ConfigurationSecurityRight.ManageDocumentThemes,

        ...new JobSecurityModule().allExceptRights([JobSecurityRight.ReverseWorkOrderStatus, JobSecurityRight.AccessQuote, JobSecurityRight.ManageQuote]),
        ...new FinanceSecurityModule().allExceptRights([FinanceSecurityRight.ManageApprovedInvoices, FinanceSecurityRight.ManageApprovedBills]),
        ...new CrmSecurityModule().allExceptRights([CrmSecurityRight.ManageSecurityRoles, CrmSecurityRight.ViewRecurringJobsWithinCustomers, CrmSecurityRight.ViewRecurringJobsWithinSites, CrmSecurityRight.ViewServicesWithinSites]),
        ...new VariationSecurityModule().allRights,
        ...new ClaimSecurityModule().allRights,
        ...new TimesheetSecurityModule().allRights,

        // DashboardSecurityRight.CanViewSystemDashboards,
        DashboardSecurityRight.CanCreateDashboards,
    ];

}

